import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import Validation from "../../common/FormValidation";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
library.add(fas);

const AddStoreModal = (props) => {
  const id = props.productId;
  const { postData, getData, Select2Data } = useContext(Context);
  const [countries, setCountries] = useState([]);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const productId = props.productId;

  // const GetEditData = async () => {
  //   const response = await getData(`/admin/products/${id}`);
  //   const selectedStores =
  //     response?.data?.Product_Stores?.map((item) => ({
  //       value: item.store_id,
  //       label: item.Store.name,
  //     })) || [];

  //   reset({
  //     store_id: selectedStores,
  //   });
  // };

  const GetAllCountry = async () => {
    const response = await getData("/common/masters/all-store");
    if (response?.success) {
      setCountries(await Select2Data(response?.data, "store_id"));
    }
  };

  useEffect(() => {
    GetAllCountry();
    // GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  useEffect(() => {
    const load = async () => {
      if (!props.show || !id) return;

      const storeRes = await getData("/common/masters/all-store");

      let options = [];
      if (storeRes?.success) {
        options = await Select2Data(storeRes.data, "store_id");
        setCountries(options);
      }

      const productRes = await getData(`/admin/products/${id}`);

      const selectedStores =
        productRes?.data?.store_id?.map((item) => ({
          value: item.value,
          label: item.label,
        })) || [];

      setTimeout(() => {
        reset({
          store_id: selectedStores,
        });
      }, 0);
    };

    load();
  }, [props.show, id]);
  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append(
        "store_id",
        JSON.stringify(data?.store_id?.map((item) => item.value) || []),
      );
      //   DataToSend.append("name", data?.name);
      const response = await putData(`/admin/products/${id}`, DataToSend);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal show={props.show} onHide={props.handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Stores
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Store</Form.Label>
                    <Controller
                      name="store_id"
                      control={control}
                      rules={{ required: "Select Stores" }}
                      render={({ field }) => (
                        <Select
                          isMulti
                          options={countries}
                          value={countries.length ? field.value || [] : []}
                          onChange={field.onChange}
                          getOptionLabel={(e) => e.label}
                          getOptionValue={(e) => e.value}
                        />
                      )}
                    />
                    {errors.store_id && (
                      <span className="text-danger">
                        {errors.store_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>State</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="State"
                          className={classNames("", {
                            "is-invalid": errors?.name,
                          })}
                          {...register("name", {
                            required: "State is required",
                               validate: (value) => {
                              const words = value.match(/\b\w+\b/g);
                              return (
                                !words ||
                                words.length <= 50 ||
                                "Data must be 100 words or less"
                              );
                            },
                          })}
                        />
                      </InputGroup>
                      {errors.name && (
                        <span className="text-danger">
                          {errors.name.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col> */}

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddStoreModal;
